import { TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { CountryPhone } from '../../../../enums/countries';
import { Address } from '../../../../types/api/clients';
import { AddressInitialValues } from '../../../../utils/constants/address';
import {
  getPhoneorMobileNumberRegion,
  isValidMobileNumber,
} from '../../../../utils/helpers/phoneNumbers';
import { yupMaxField, yupRequiredField } from '../../../../utils/helpers/yup';
import { getAddressSchema } from '../../../validations/address';

export type FormFields = {
  legal_entity: boolean;
  name: string;
  email: string;
  phone: string;
  phone_region: CountryPhone;
  tax_number: string;
  address: Address;
};

export function getInitialValues(): FormFields {
  return {
    legal_entity: false,
    name: '',
    email: '',
    phone: '',
    phone_region: getPhoneorMobileNumberRegion(''),
    tax_number: '',
    address: AddressInitialValues,
  };
}

export function getValidationSchema(t: TFunction) {
  return Yup.object().shape({
    name: Yup.string().required(yupRequiredField(t, t('Name'))),
    phone: Yup.string().test(
      'phone',
      t('Invalid mobile phone number'),
      (value, context): boolean => {
        if (!value) {
          return true;
        }

        const { phone_region } = context.parent;
        return isValidMobileNumber(value, phone_region);
      }
    ),
    email: Yup.string()
      .required(yupRequiredField(t, t('Email')))
      .email()
      .max(254, yupMaxField(t, t('Email'), 254)),
    tax_number: Yup.string().when('legal_entity', {
      is: true,
      then: Yup.string()
        .max(45, yupMaxField(t, t('Tax Number'), 45))
        .required(yupRequiredField(t, t('Tax Number'))),
    }),
    address: getAddressSchema(t, { municipality: true }),
  });
}
